export const TRIPX_AFFILIATE = 'tripx_affiliate';
export const KAYAKCLICKID = 'kayakclickid';
export const TDUID = 'tduid';
export const USER_BOOKING_CREDENTIALS = 'user_booking_credentials';
export const COOKIECONSENT_STATUS = 'cookieconsent_status';
export const AGENT_ID = 'agent_id';
export const EXTERNAL_REFERENCE_ID = 'external_reference_id';
export const NEW_COOKIECONSENT_STATUS = 'new_cookieconsent_status';
export const MASTER_DOMAIN_ABANDONED_CART = 'masterdomain_abandoned_cart';
export const CLARITY_USER_ID = "_clck"